<template>
    <div>
        <div class="col-lg-12">
            <ExportLandingPage :listBlockLP="dataForm.blocks_settings" :dataForm="dataForm" />
        </div>
    </div>
</template>

<script>
import ExportLandingPage from '../export-page/main.vue';

export default {
    name: 'SettingBlockLP',
    components: { ExportLandingPage },
    props: {
        dataForm: {
            type: Object,
            required: true,
            default: () => null
        }
    },

    data() {
        return {};
    },
    methods: {}
};
</script>

<style lang="scss"></style>
